import React, { FC, ReactElement } from 'react';
import { Breadcrumb } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { getRouterType, getRouterTypeByRoot } from 'routers'
import styles from "./index.less";


const NavBar: FC = (props:any) : ReactElement=> {

  // 根据路由读取导航数据
  const path = props.match.path
  const params = props.match.params
  const rtType = getRouterType(path)
  
  const rootRt = getRouterTypeByRoot(rtType.root)
  const len = rootRt.length
  const bcArr = rootRt.map((rt, idx)=>{
    let path = rt.path
    if(params){
      for(let key in params){
        path = path.replace(':'+key, params[key])
      }
    }
    return {
      ...rt,
      path,
      title: props[rt.name] ? props[rt.name] : rt.meta.title,
      isEnd: idx===len-1
    }
  })

  return (
    <Breadcrumb separator={<RightOutlined />}>
      {
        bcArr.map((rt, idx)=>{
          return <Breadcrumb.Item className={styles.customNvabarItem} key={rt.name}>
            {
              !rt.isEnd && 
              <Link to={rt.path}>{rt.title}</Link>
            }
            { rt.isEnd && rt.title }
          </Breadcrumb.Item>
        })
      }
  </Breadcrumb>
  )
}

export default NavBar